// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.logo_wrapper {
  height: 50vh;
  width: 100%;
  align-items: center;
  justify-content: center;
  margin-top: 20%;
}

.screen {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

body {
  padding: 0;
  margin: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.screen {
  /* background-color: #55198b; */
  overflow: hidden;
  border-radius: 100%;
  animation: grow 5.5s forwards;
}

.loading {
  margin: 0;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.ball {
  width: 90px;
  height: 10px;
  margin: 7px auto;
  border-radius: 50px;
}
.ball:nth-child(1) {
  background: #ff005d;
  animation: right 1s infinite ease-in-out;
}

.ball:nth-child(2) {
  background: #35ff99;
  animation: left 1.1s infinite ease-in-out;
}

.ball:nth-child(3) {
  background: #008597;
  animation: right 1.05s infinite ease-in-out;
}

.ball:nth-child(4) {
  background: #ffcc00;
  animation: left 1.15s infinite ease-in-out;
}

.ball:nth-child(5) {
  background: #2d3443;
  animation: right 1.1s infinite ease-in-out;
}

.ball:nth-child(6) {
  background: #ff7c35;
  animation: left 1.05s infinite ease-in-out;
}

.ball:nth-child(7) {
  background: #4d407c;
  animation: right 1s infinite ease-in-out;
}

@keyframes right {
  0% {
    transform: translate(-15px);
  }
  50% {
    transform: translate(15px);
  }
  100% {
    transform: translate(-15px);
  }
}

@keyframes left {
  0% {
    transform: translate(15px);
  }
  50% {
    transform: translate(-15px);
  }
  100% {
    transform: translate(15px);
  }
}

@keyframes grow {
  0% {
    transform: scale(0);
  }
  10% {
    transform: scale(1);
    border-radius: 0%;
    height: 100%;
    width: 100%;
  }
  90% {
    transform: scale(1);
    border-radius: 0%;
    height: 100%;
    width: 100%;
  }
  100% {
    transform: scale(0);
    transform-origin: 50% 50%;
    border-radius: 100%;
  }
}

#logo {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
`, "",{"version":3,"sources":["webpack://./src/pages/splash/Splash.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,UAAU;EACV,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,+BAA+B;EAC/B,gBAAgB;EAChB,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,QAAQ;EACR,SAAS;EAET,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,mBAAmB;EAGnB,wCAAwC;AAC1C;;AAEA;EACE,mBAAmB;EAGnB,yCAAyC;AAC3C;;AAEA;EACE,mBAAmB;EAGnB,2CAA2C;AAC7C;;AAEA;EACE,mBAAmB;EAGnB,0CAA0C;AAC5C;;AAEA;EACE,mBAAmB;EAGnB,0CAA0C;AAC5C;;AAEA;EACE,mBAAmB;EAGnB,0CAA0C;AAC5C;;AAEA;EACE,mBAAmB;EAGnB,wCAAwC;AAC1C;;AAkDA;EACE;IACE,2BAA2B;EAC7B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,2BAA2B;EAC7B;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;IACnB,iBAAiB;IACjB,YAAY;IACZ,WAAW;EACb;EACA;IACE,mBAAmB;IACnB,iBAAiB;IACjB,YAAY;IACZ,WAAW;EACb;EACA;IACE,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;EACrB;AACF;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;AAClC","sourcesContent":[".logo_wrapper {\n  height: 50vh;\n  width: 100%;\n  align-items: center;\n  justify-content: center;\n  margin-top: 20%;\n}\n\n.screen {\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\nbody {\n  padding: 0;\n  margin: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.screen {\n  /* background-color: #55198b; */\n  overflow: hidden;\n  border-radius: 100%;\n  animation: grow 5.5s forwards;\n}\n\n.loading {\n  margin: 0;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  -ms-transform: translate(-50%, -50%);\n  transform: translate(-50%, -50%);\n}\n\n.ball {\n  width: 90px;\n  height: 10px;\n  margin: 7px auto;\n  border-radius: 50px;\n}\n.ball:nth-child(1) {\n  background: #ff005d;\n  -webkit-animation: right 1s infinite ease-in-out;\n  -moz-animation: right 1s infinite ease-in-out;\n  animation: right 1s infinite ease-in-out;\n}\n\n.ball:nth-child(2) {\n  background: #35ff99;\n  -webkit-animation: left 1.1s infinite ease-in-out;\n  -moz-animation: left 1.1s infinite ease-in-out;\n  animation: left 1.1s infinite ease-in-out;\n}\n\n.ball:nth-child(3) {\n  background: #008597;\n  -webkit-animation: right 1.05s infinite ease-in-out;\n  -moz-animation: right 1.05s infinite ease-in-out;\n  animation: right 1.05s infinite ease-in-out;\n}\n\n.ball:nth-child(4) {\n  background: #ffcc00;\n  -webkit-animation: left 1.15s infinite ease-in-out;\n  -moz-animation: left 1.15s infinite ease-in-out;\n  animation: left 1.15s infinite ease-in-out;\n}\n\n.ball:nth-child(5) {\n  background: #2d3443;\n  -webkit-animation: right 1.1s infinite ease-in-out;\n  -moz-animation: right 1.1s infinite ease-in-out;\n  animation: right 1.1s infinite ease-in-out;\n}\n\n.ball:nth-child(6) {\n  background: #ff7c35;\n  -webkit-animation: left 1.05s infinite ease-in-out;\n  -moz-animation: left 1.05s infinite ease-in-out;\n  animation: left 1.05s infinite ease-in-out;\n}\n\n.ball:nth-child(7) {\n  background: #4d407c;\n  -webkit-animation: right 1s infinite ease-in-out;\n  -moz-animation: right 1s infinite ease-in-out;\n  animation: right 1s infinite ease-in-out;\n}\n\n@-webkit-keyframes right {\n  0% {\n    -webkit-transform: translate(-15px);\n  }\n  50% {\n    -webkit-transform: translate(15px);\n  }\n  100% {\n    -webkit-transform: translate(-15px);\n  }\n}\n\n@-webkit-keyframes left {\n  0% {\n    -webkit-transform: translate(15px);\n  }\n  50% {\n    -webkit-transform: translate(-15px);\n  }\n  100% {\n    -webkit-transform: translate(15px);\n  }\n}\n\n@-moz-keyframes right {\n  0% {\n    -moz-transform: translate(-15px);\n  }\n  50% {\n    -moz-transform: translate(15px);\n  }\n  100% {\n    -moz-transform: translate(-15px);\n  }\n}\n\n@-moz-keyframes left {\n  0% {\n    -moz-transform: translate(15px);\n  }\n  50% {\n    -moz-transform: translate(-15px);\n  }\n  100% {\n    -moz-transform: translate(15px);\n  }\n}\n\n@keyframes right {\n  0% {\n    transform: translate(-15px);\n  }\n  50% {\n    transform: translate(15px);\n  }\n  100% {\n    transform: translate(-15px);\n  }\n}\n\n@keyframes left {\n  0% {\n    transform: translate(15px);\n  }\n  50% {\n    transform: translate(-15px);\n  }\n  100% {\n    transform: translate(15px);\n  }\n}\n\n@keyframes grow {\n  0% {\n    transform: scale(0);\n  }\n  10% {\n    transform: scale(1);\n    border-radius: 0%;\n    height: 100%;\n    width: 100%;\n  }\n  90% {\n    transform: scale(1);\n    border-radius: 0%;\n    height: 100%;\n    width: 100%;\n  }\n  100% {\n    transform: scale(0);\n    transform-origin: 50% 50%;\n    border-radius: 100%;\n  }\n}\n\n#logo {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
